import React from 'react'
import styled from 'styled-components'
import { device } from '../../config/theme/breakpoints'

const ContainerAlert = styled.div`
  width: 100%;
  border-radius: 20px;
  border: 1px solid ${p => p.theme.palette.primary.main};
  display: flex;
  flex-direction: column;

  @media ${device.mobileL}{
    flex-direction: row;
  }
`
const ContainerIcon = styled.div`
  background: ${p => p.theme.palette.primary.main};
  border-radius: 20px 20px 0 0;
  width: 100%;
  padding: 20px;
  display: flex;
  jutify-content: center;
  align-items: center;

  > svg{
    max-width: 80px;
    color: white;
    margin: auto;
  }

  @media ${device.mobileL}{
    max-width: 200px;
    border-radius: 18px 0 0 18px;
  }
`

const ContainerText = styled.div<{ background: string }>`
  padding: 8px 15px;
  background: ${p => p.background};

  > h3 {
    color: ${p => p.theme.palette.text.primary};
    text-align: center;

    @media ${device.mobileL}{
      text-align: left;
    }
  }

  > p {
    font-weight: 100;
    font-size: 13px;
  }
`

interface IOwnProps {
    icon: React.ReactElement
    title: string;
    description: string;
    backgroundBodyText?: string;
}

const AlertTC: React.FunctionComponent<IOwnProps> = ({
  icon,
  title,
  description,
  backgroundBodyText = ''
}) => {
  return (
    <ContainerAlert>
      <ContainerIcon>
        {icon}
      </ContainerIcon>
      <ContainerText background={backgroundBodyText}>
        <h3>{title}</h3>
        <p>{description}</p>
      </ContainerText>
    </ContainerAlert>
  )
}

export default AlertTC